export const switchTopology = [
  {
    "field": "device_link_to_switch",
    "headerName": "Storage (Array)",
  },
  {
    "field": "device_port_num",
    "headerName": "Array Port #",
  },
  {
    "field": "storage_wwn",
    "headerName": "Array WWPN",
  },
  {
    "field": "storage_port_alias",
    "headerName": "Array Port Alias",
    "hide": true,
  },
  {
    "field": "zone_name",
    "headerName": "Zone",
  },
  {
    "field": "switch_name",
    "headerName": "Switch",
  },
  // {
  //   "field": "switch_port_count_total",
  //   "headerName": "Switch Port Count",
  // },
  // {
  //   "field": "associated_port",
  //   "headerName": "Associated Port",
  // },
  {
    "field": "host_name",
    "headerName": "Host",
  },
  {
    "field": "host_port_num",
    "headerName": "Host Port #",
  },
  {
    "field": "host_wwn",
    "headerName": "Host WWPN",
  },
  {
    "field": "host_switch_port_name",
    "headerName": "Host Port Alias",
  },
]